import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=077abdbc&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=077abdbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077abdbc",
  null
  
)

export default component.exports